
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loggedIn: false, // Initial state when no user is logged in
    role: '', // Role of the logged-in user ('admin' or 'analyst')
    adminPages: [
        'adminApplication',
        'dashboard',
        'teams',
        'teamAdminEmptystate',
        'customerProfile',
        'models',
        'adminSettingsPage',
        'faq',
        'chat',
    ],
    analystPages: [
        'applications',
        'applicationsAnalystEmptyState',
        'dashboard',
        'analystSettingsPage',
        'faq',
        'chat',
    ],
};

const pagesViewSlice = createSlice({
    name: 'pagesView',
    initialState,
    reducers: {
        login(state, action) {
            state.loggedIn = true;
            state.role = action.payload;
        },
        logout(state) {
            state.loggedIn = false;
            state.role = '';
        },
    }
});

export const { login, logout } = pagesViewSlice.actions;

export default pagesViewSlice;
